import home from './home'
import terms from './terms'
import user from './user'
import sales from './sales'
import product from './product'
import login from './login'
import sample from './sample'
import bill from './bill'
import contract from './contract'
import notice from './notice'
import servicerequest from './servicerequest'

export default [].concat(
  home,
  terms,
  user,
  sales,
  product,
  login,
  sample,
  bill,
  contract,
  notice,
  servicerequest
)



// WEBPACK FOOTER //
// ./src/router/children/index.js